"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateGestureAnimation = void 0;
/**
 * This migration got introduced because we have switched to using animation key rather than full url.
 * And some old data contain full url causing issues.
 */
const migrateGestureAnimation = async (dialog) => {
    console.info('migrateGestureAnimation');
    const steps = dialog.steps.map((step) => {
        const gestures = step.gestures.map((gesture) => {
            var _a, _b;
            const isUrl = (_a = gesture.gesture) === null || _a === void 0 ? void 0 : _a.startsWith('https');
            if (isUrl) {
                return {
                    ...gesture,
                    gesture: (_b = gesture.gesture.split('/').pop()) === null || _b === void 0 ? void 0 : _b.split('?').shift(),
                };
            }
            return gesture;
        });
        return {
            ...step,
            gestures,
        };
    });
    return {
        ...dialog,
        steps
    };
};
exports.migrateGestureAnimation = migrateGestureAnimation;
//# sourceMappingURL=migrateGestureAnimation.js.map